<footer class="footer">
  <div class="footer__content">
    <div class="footer__top">
      <a class="footer__logo" [routerLink]="globals.routes()['homepage'].url">
        <app-icon [icon]="'logo'" [height]="32">{{ 'globals.webTitle' | translate }}</app-icon>
      </a>
    </div>
    <div class="footer__middle">
      <ul class="footer__navigation">
        @for (item of navigationService.navigation(); track $index) {
          @if (item.footer) {
            <li class="footer__navigation-item">
              <app-underline-link class="footer__navigation-link" [route]="item.route | link: 'route'" [href]="item.route | link: 'href'" [target]="(item.route | link: 'href') ? '_blank' : undefined">{{ item.title }}</app-underline-link>
            </li>
          }
        }
      </ul>

      <div class="footer__right">
        <span class="footer__translate" [ngClass]="{ 'footer__translate--active': popoverService.activeId() === 'translate-popover' }" [app-popover]="'translate-popover'">
          <app-image [src]="googleTranslateService.activeLanguage() === 'en' ? '/images/flags/gb.svg' : '/images/flags/cz.svg'" [width]="24" [height]="24"></app-image>
          <app-icon class="footer__translate-icon" [icon]="'chevron-bold'" [width]="14" [rotate]="90"></app-icon>
        </span>
        <ul class="footer__socials">
          <li>
            <a class="footer__socials-link" [href]="'globals.contactData.facebook' | translate" target="_blank"><app-icon [icon]="'facebook'" [width]="24">Facebook</app-icon></a>
          </li>
          <li>
            <a class="footer__socials-link" [href]="'globals.contactData.instagram' | translate" target="_blank"><app-icon [icon]="'instagram'" [width]="24">Instagram</app-icon></a>
          </li>
        </ul>
      </div>
      <app-popover [id]="'translate-popover'" [width]="140" [mobile-title]="'globals.translate.title' | translate" [high-z-index]="true" [in-box]="true">
        <span class="footer__translate-item" (click)="translate('cs')"><app-image [src]="'/images/flags/cz.svg'" [width]="24" [height]="24"></app-image> {{ 'globals.translate.cs' | translate }}</span>
        <span class="footer__translate-item" (click)="translate('en')"><app-image [src]="'/images/flags/gb.svg'" [width]="24" [height]="24"></app-image> {{ 'globals.translate.en' | translate }}</span>
      </app-popover>
    </div>
    <div class="footer__copyright">
      &copy; {{ globals.year }} Mototechna
      <ul class="footer__copyright-navigation">
        @for (item of navigationService.navigation(); track $index) {
          @if (item.bottom) {
            <li>
              @if (item.route === 'cookies-modal') {
                <span class="footer__copyright-navigation-link" data-cookiebar-open="true">{{ item.title }}</span>
              } @else {
                <a class="footer__copyright-navigation-link" [routerLink]="item.route">{{ item.title }}</a>
              }
            </li>
          }
        }
      </ul>
    </div>
  </div>
</footer>
